// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Mulish&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InformeTecnicoNivelesBajos{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-family: 'Mulish', sans-serif;
    font-weight: 300;    
}
.tituloylogo{
    display: flex;
}
.tituloylogo .logo{
    width: 20vh;
    height: 20vh;
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 0vh;
}
.GraficosInformeTecnico{
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
}
.FilaInformeTecnico{
    display: flex;
    flex-direction: row;
}
.GraficoYLeyendaTecnico{
    margin-right: 2vh;
    margin-left: 2vh;
    display: flex;
    flex-direction: row;
    align-items: center;
}
.Leyendas{
    display: flex;
    flex-direction: column;
    width: 75%;
}
.Leyenda{
    display: flex;
    flex-direction: row;
}
.Leyendas a{
    text-decoration: none;
    color: black;
}
/* responsive design */

@media screen and (max-width: 833px) {
    .InformeTecnico {
        flex-direction: column;
    }
    .GraficosInformeTecnico {
        width: 100%;
    }
    .FilaInformeTecnico {
        flex-direction: column;
    }
    .GraficoYLeyendaTecnico {
        margin-top: 2vh;
        margin-right: 0;
        margin-left: 0;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .Leyendas {
        width: 100%;
        align-items: center;
    }
}

@media screen and (max-width: 700px) {
    .tituloylogo{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .tituloylogo .logo{
        position: relative;
    }
}`, "",{"version":3,"sources":["webpack://./src/static/css/InformeTecnicoNivelesBajos.css"],"names":[],"mappings":"AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;IACjC,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,eAAe;AACnB;AACA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,YAAY;AAChB;AACA,sBAAsB;;AAEtB;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;IACf;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,eAAe;QACf,cAAc;QACd,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Mulish&display=swap');\n.InformeTecnicoNivelesBajos{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    font-family: 'Mulish', sans-serif;\n    font-weight: 300;    \n}\n.tituloylogo{\n    display: flex;\n}\n.tituloylogo .logo{\n    width: 20vh;\n    height: 20vh;\n    position: absolute;\n    top: 0;\n    left: 0;\n    margin-top: 0vh;\n}\n.GraficosInformeTecnico{\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n.FilaInformeTecnico{\n    display: flex;\n    flex-direction: row;\n}\n.GraficoYLeyendaTecnico{\n    margin-right: 2vh;\n    margin-left: 2vh;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n.Leyendas{\n    display: flex;\n    flex-direction: column;\n    width: 75%;\n}\n.Leyenda{\n    display: flex;\n    flex-direction: row;\n}\n.Leyendas a{\n    text-decoration: none;\n    color: black;\n}\n/* responsive design */\n\n@media screen and (max-width: 833px) {\n    .InformeTecnico {\n        flex-direction: column;\n    }\n    .GraficosInformeTecnico {\n        width: 100%;\n    }\n    .FilaInformeTecnico {\n        flex-direction: column;\n    }\n    .GraficoYLeyendaTecnico {\n        margin-top: 2vh;\n        margin-right: 0;\n        margin-left: 0;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    .Leyendas {\n        width: 100%;\n        align-items: center;\n    }\n}\n\n@media screen and (max-width: 700px) {\n    .tituloylogo{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n    }\n    .tituloylogo .logo{\n        position: relative;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
